import PeopleIcon from "@mui/icons-material/People";
import StoreIcon from "@mui/icons-material/Store";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import StarIcon from "@mui/icons-material/Star";

export const demoEvents = [
  // --- Your Original 4 Events ---
  {
    id: 1,
    title: "Live Jazz Night",
    start: new Date(2026, 6, 3, 20, 0), // July 3, 2026, 8:00 PM
    end: new Date(2026, 6, 3, 23, 0),
    desc: "Enjoy a night of smooth jazz and great drinks.",
    imageUrl: "https://placehold.co/600x400?text=Jazz",
    eventType: "Live Music",
  },
  {
    id: 2,
    title: "Summer Food Festival",
    start: new Date(2026, 6, 6, 11, 0), // July 6, 2026, 11:00 AM
    end: new Date(2026, 7, 6, 18, 0), // Spans a whole month to Aug 6
    desc: "Local vendors sharing their best dishes in the town square.",
    imageUrl: "https://placehold.co/600x400?text=Food",
    eventType: "Festival",
  },
  {
    id: 3,
    title: "Tech Meetup: ASP.NET & React",
    start: new Date(2026, 6, 6, 18, 30), // July 6, 2026, 6:30 PM
    end: new Date(2026, 6, 6, 20, 30),
    desc: "A deep dive into connecting Web API 2 with modern frontend frameworks.",
    imageUrl: "https://placehold.co/600x400?text=Tech",
    eventType: "Seminar",
  },
  {
    id: 4,
    title: "Overlapping Event 1",
    start: new Date(2026, 6, 6, 19, 30), // July 6, 2026, 7:30 PM
    end: new Date(2026, 6, 6, 21, 30), // July 6, 2026, 9:30 PM
    desc: "A deep dive into connecting Web API 2 with modern frontend frameworks.",
    imageUrl: "https://placehold.co/600x400?text=Art",
    eventType: "Live Music",
  },

  // --- Generated Events for July 2026 ---

  // Week 1 (July 1 - July 5)
  {
    id: 5,
    title: "Midweek Farmers Market",
    start: new Date(2026, 6, 1, 8, 0),
    end: new Date(2026, 6, 1, 14, 0),
    desc: "Fresh local produce, homemade breads, and organic honey in the town square.",
    imageUrl: "https://placehold.co/600x400?text=Farmers+Market",
    eventType: "Market",
  },
  {
    id: 6,
    title: "Poetry Reading & Open Mic",
    start: new Date(2026, 6, 1, 19, 0),
    end: new Date(2026, 6, 1, 21, 0),
    desc: "Local poets share their work at the central library café.",
    imageUrl: "https://placehold.co/600x400?text=Poetry",
    eventType: "Arts & Culture",
  },
  {
    id: 7,
    title: "Food Truck Thursday",
    start: new Date(2026, 6, 2, 17, 0),
    end: new Date(2026, 6, 2, 22, 0),
    desc: "A convoy of street food trucks serving global cuisines.",
    imageUrl: "https://placehold.co/600x400?text=Food+Trucks",
    eventType: "Food & Drink",
  },
  {
    id: 8,
    title: "Town Hall Open Forum",
    start: new Date(2026, 6, 2, 18, 30),
    end: new Date(2026, 6, 2, 20, 0),
    desc: "Discuss upcoming community projects with local council members.",
    imageUrl: "https://placehold.co/600x400?text=Community",
    eventType: "Community",
  },
  {
    id: 9,
    title: "First Friday Art Walk",
    start: new Date(2026, 6, 3, 17, 0),
    end: new Date(2026, 6, 3, 21, 0),
    desc: "Explore local galleries with free wine and cheese.",
    imageUrl: "https://placehold.co/600x400?text=Art+Walk",
    eventType: "Arts & Culture",
  },
  {
    id: 10,
    title: "Saturday Antiques Fair",
    start: new Date(2026, 6, 4, 9, 0),
    end: new Date(2026, 6, 4, 15, 0),
    desc: "Discover hidden gems and vintage collectibles.",
    imageUrl: "https://placehold.co/600x400?text=Antiques",
    eventType: "Market",
  },
  {
    id: 11,
    title: "Acoustic Afternoon in the Park",
    start: new Date(2026, 6, 4, 13, 0),
    end: new Date(2026, 6, 4, 16, 0),
    desc: "Bring a picnic and enjoy local acoustic bands.",
    imageUrl: "https://placehold.co/600x400?text=Acoustic",
    eventType: "Live Music",
  },
  {
    id: 12,
    title: "Sunday Car Boot Sale",
    start: new Date(2026, 6, 5, 7, 30),
    end: new Date(2026, 6, 5, 12, 30),
    desc: "Bargain hunting at the community center car park.",
    imageUrl: "https://placehold.co/600x400?text=Car+Boot",
    eventType: "Market",
  },

  // Week 2 (July 6 - July 12)
  {
    id: 13,
    title: "Yoga in the Gardens",
    start: new Date(2026, 6, 7, 7, 0),
    end: new Date(2026, 6, 7, 8, 0),
    desc: "Free morning yoga session to start your Tuesday right.",
    imageUrl: "https://placehold.co/600x400?text=Yoga",
    eventType: "Community",
  },
  {
    id: 14,
    title: "Craft Beer Tasting",
    start: new Date(2026, 6, 7, 19, 0),
    end: new Date(2026, 6, 7, 21, 30),
    desc: "Sample local microbrews at the Red Lion Pub.",
    imageUrl: "https://placehold.co/600x400?text=Craft+Beer",
    eventType: "Food & Drink",
  },
  {
    id: 15,
    title: "Midweek Farmers Market",
    start: new Date(2026, 6, 8, 8, 0),
    end: new Date(2026, 6, 8, 14, 0),
    desc: "Fresh local produce in the town square.",
    imageUrl: "https://placehold.co/600x400?text=Farmers+Market",
    eventType: "Market",
  },
  {
    id: 16,
    title: "Local History Walk",
    start: new Date(2026, 6, 8, 14, 0),
    end: new Date(2026, 6, 8, 16, 0),
    desc: "Guided tour exploring the town's architectural heritage.",
    imageUrl: "https://placehold.co/600x400?text=History",
    eventType: "Arts & Culture",
  },
  {
    id: 17,
    title: "Pub Quiz: Pop Culture",
    start: new Date(2026, 6, 9, 20, 0),
    end: new Date(2026, 6, 9, 22, 30),
    desc: "Weekly pub quiz with cash prizes.",
    imageUrl: "https://placehold.co/600x400?text=Pub+Quiz",
    eventType: "Pub Quiz",
  },
  {
    id: 18,
    title: "Weekend Makers Market (Day 1)",
    start: new Date(2026, 6, 10, 10, 0),
    end: new Date(2026, 6, 10, 17, 0), // Multi-day event split for cleaner rendering, or span it
    desc: "Handmade crafts, jewelry, and art from local creators.",
    imageUrl: "https://placehold.co/600x400?text=Makers+Market",
    eventType: "Market",
  },
  {
    id: 19,
    title: "Open Air Cinema: Classic Movies",
    start: new Date(2026, 6, 10, 21, 0),
    end: new Date(2026, 6, 10, 23, 30),
    desc: "Outdoor screening under the stars. Bring your own blanket.",
    imageUrl: "https://placehold.co/600x400?text=Cinema",
    eventType: "Arts & Culture",
  },
  {
    id: 20,
    title: "Weekend Makers Market (Day 2)",
    start: new Date(2026, 6, 11, 10, 0),
    end: new Date(2026, 6, 11, 17, 0),
    desc: "Handmade crafts, jewelry, and art from local creators.",
    imageUrl: "https://placehold.co/600x400?text=Makers+Market",
    eventType: "Market",
  },
  {
    id: 21,
    title: "Town Center Parade",
    start: new Date(2026, 6, 11, 12, 0),
    end: new Date(2026, 6, 11, 13, 30),
    desc: "Annual summer parade featuring local schools and businesses.",
    imageUrl: "https://placehold.co/600x400?text=Parade",
    eventType: "Festival",
  },
  {
    id: 22,
    title: "Charity 5K Run",
    start: new Date(2026, 6, 12, 9, 0),
    end: new Date(2026, 6, 12, 11, 0),
    desc: "Running to raise funds for the local children's hospital.",
    imageUrl: "https://placehold.co/600x400?text=5K+Run",
    eventType: "Community",
  },

  // Week 3 (July 13 - July 19)
  {
    id: 23,
    title: "Book Club Meeting",
    start: new Date(2026, 6, 13, 18, 0),
    end: new Date(2026, 6, 13, 19, 30),
    desc: "Discussing this month's thriller novel at the café.",
    imageUrl: "https://placehold.co/600x400?text=Book+Club",
    eventType: "Community",
  },
  {
    id: 24,
    title: "Vegan Food Fair",
    start: new Date(2026, 6, 14, 11, 0),
    end: new Date(2026, 6, 14, 16, 0),
    desc: "Plant-based treats and sustainable goods.",
    imageUrl: "https://placehold.co/600x400?text=Vegan+Fair",
    eventType: "Food & Drink",
  },
  {
    id: 25,
    title: "Midweek Farmers Market",
    start: new Date(2026, 6, 15, 8, 0),
    end: new Date(2026, 6, 15, 14, 0),
    desc: "Fresh local produce in the town square.",
    imageUrl: "https://placehold.co/600x400?text=Farmers+Market",
    eventType: "Market",
  },
  {
    id: 26,
    title: "Photography Exhibition Opening",
    start: new Date(2026, 6, 15, 18, 0),
    end: new Date(2026, 6, 15, 21, 0),
    desc: "Showcasing landscapes from local photographers.",
    imageUrl: "https://placehold.co/600x400?text=Photography",
    eventType: "Arts & Culture",
  },
  {
    id: 27,
    title: "Salsa Dancing Workshop",
    start: new Date(2026, 6, 16, 19, 0),
    end: new Date(2026, 6, 16, 21, 0),
    desc: "Beginners welcome! Learn the basics of Salsa.",
    imageUrl: "https://placehold.co/600x400?text=Salsa",
    eventType: "Arts & Culture",
  },
  {
    id: 28,
    title: "Indie Rock Showcase",
    start: new Date(2026, 6, 17, 20, 0),
    end: new Date(2026, 6, 17, 23, 30),
    desc: "Three up-and-coming indie bands play live.",
    imageUrl: "https://placehold.co/600x400?text=Indie+Rock",
    eventType: "Live Music",
  },
  {
    id: 29,
    title: "Street Food & Music Festival",
    start: new Date(2026, 6, 18, 12, 0), // Multi-day event
    end: new Date(2026, 6, 19, 22, 0),
    desc: "A massive two-day block party with food vendors and live stages.",
    imageUrl: "https://placehold.co/600x400?text=Street+Fest",
    eventType: "Festival",
  },
  {
    id: 30,
    title: "Kids Craft Morning",
    start: new Date(2026, 6, 19, 10, 0),
    end: new Date(2026, 6, 19, 12, 0),
    desc: "Free painting and crafts for under 10s at the library.",
    imageUrl: "https://placehold.co/600x400?text=Kids+Crafts",
    eventType: "Community",
  },

  // Week 4 (July 20 - July 26)
  {
    id: 31,
    title: "Business Networking Breakfast",
    start: new Date(2026, 6, 20, 7, 30),
    end: new Date(2026, 6, 20, 9, 0),
    desc: "Connect with local business owners over coffee and pastries.",
    imageUrl: "https://placehold.co/600x400?text=Networking",
    eventType: "Seminar",
  },
  {
    id: 32,
    title: "Stand-up Comedy Night",
    start: new Date(2026, 6, 21, 20, 0),
    end: new Date(2026, 6, 21, 22, 30),
    desc: "Four comedians bring the laughs to the local theater.",
    imageUrl: "https://placehold.co/600x400?text=Comedy",
    eventType: "Arts & Culture",
  },
  {
    id: 33,
    title: "Midweek Farmers Market",
    start: new Date(2026, 6, 22, 8, 0),
    end: new Date(2026, 6, 22, 14, 0),
    desc: "Fresh local produce in the town square.",
    imageUrl: "https://placehold.co/600x400?text=Farmers+Market",
    eventType: "Market",
  },
  {
    id: 34,
    title: "Wine & Paint Night",
    start: new Date(2026, 6, 22, 18, 30),
    end: new Date(2026, 6, 22, 21, 0),
    desc: "Follow a guided painting tutorial while enjoying house wines.",
    imageUrl: "https://placehold.co/600x400?text=Paint+Night",
    eventType: "Arts & Culture",
  },
  {
    id: 35,
    title: "Pub Quiz: Music Intro Round",
    start: new Date(2026, 6, 23, 20, 0),
    end: new Date(2026, 6, 23, 22, 30),
    desc: "Test your musical knowledge.",
    imageUrl: "https://placehold.co/600x400?text=Pub+Quiz",
    eventType: "Pub Quiz",
  },
  {
    id: 36,
    title: "Grand Opening: New Bakery",
    start: new Date(2026, 6, 24, 8, 0),
    end: new Date(2026, 6, 24, 16, 0),
    desc: "Free samples and ribbon cutting at the new high street bakery.",
    imageUrl: "https://placehold.co/600x400?text=Grand+Opening",
    eventType: "Grand Openings",
  },
  {
    id: 37,
    title: "Record Fair & Vinyl Exchange",
    start: new Date(2026, 6, 25, 10, 0),
    end: new Date(2026, 6, 25, 16, 0),
    desc: "Buy, sell, and trade classic vinyl records.",
    imageUrl: "https://placehold.co/600x400?text=Vinyl",
    eventType: "Market",
  },
  {
    id: 38,
    title: "Blues & BBQ Festival",
    start: new Date(2026, 6, 25, 13, 0), // Overlaps with Record Fair
    end: new Date(2026, 6, 25, 21, 0),
    desc: "Slow-cooked meats and fast-paced blues music.",
    imageUrl: "https://placehold.co/600x400?text=Blues+BBQ",
    eventType: "Festival",
  },
  {
    id: 39,
    title: "Sunday Flower Market",
    start: new Date(2026, 6, 26, 9, 0),
    end: new Date(2026, 6, 26, 14, 0),
    desc: "Beautiful seasonal blooms and houseplants.",
    imageUrl: "https://placehold.co/600x400?text=Flowers",
    eventType: "Market",
  },

  // Week 5 (July 27 - July 31)
  {
    id: 40,
    title: "Morning Yoga in the Gardens",
    start: new Date(2026, 6, 28, 7, 0),
    end: new Date(2026, 6, 28, 8, 0),
    desc: "Start your morning with a relaxing stretch.",
    imageUrl: "https://placehold.co/600x400?text=Yoga",
    eventType: "Community",
  },
  {
    id: 41,
    title: "Coding for Kids: Scratch Basics",
    start: new Date(2026, 6, 28, 16, 0),
    end: new Date(2026, 6, 28, 17, 30),
    desc: "Free after-school programming workshop.",
    imageUrl: "https://placehold.co/600x400?text=Coding",
    eventType: "Community",
  },
  {
    id: 42,
    title: "Midweek Farmers Market",
    start: new Date(2026, 6, 29, 8, 0),
    end: new Date(2026, 6, 29, 14, 0),
    desc: "Fresh local produce in the town square.",
    imageUrl: "https://placehold.co/600x400?text=Farmers+Market",
    eventType: "Market",
  },
  {
    id: 43,
    title: "Seminar: Digital Marketing for Local Shops",
    start: new Date(2026, 6, 29, 14, 0),
    end: new Date(2026, 6, 29, 16, 0),
    desc: "Learn how to boost local foot traffic online.",
    imageUrl: "https://placehold.co/600x400?text=Seminar",
    eventType: "Seminar",
  },
  {
    id: 44,
    title: "Pop-Up Thrift Shop",
    start: new Date(2026, 6, 29, 10, 0),
    end: new Date(2026, 6, 31, 18, 0), // 3-day pop-up
    desc: "Vintage clothing pop-up running through the end of the week.",
    imageUrl: "https://placehold.co/600x400?text=Thrift",
    eventType: "Market",
  },
  {
    id: 45,
    title: "Open Mic Night",
    start: new Date(2026, 6, 30, 20, 0),
    end: new Date(2026, 6, 30, 23, 0),
    desc: "Singers, comedians, and poets take the stage.",
    imageUrl: "https://placehold.co/600x400?text=Open+Mic",
    eventType: "Live Music",
  },
  {
    id: 46,
    title: "End of Month DJ Set",
    start: new Date(2026, 6, 31, 21, 0),
    end: new Date(2026, 6, 31, 23, 59),
    desc: "Dance into August with local DJs.",
    imageUrl: "https://placehold.co/600x400?text=DJ+Set",
    eventType: "Live Music",
  },
  {
    id: 47,
    title: "Night Market & Illumination",
    start: new Date(2026, 6, 31, 18, 0), // Overlapping final Friday
    end: new Date(2026, 6, 31, 23, 0),
    desc: "Late-night shopping with lantern displays.",
    imageUrl: "https://placehold.co/600x400?text=Night+Market",
    eventType: "Market",
  },
  {
    id: 48,
    title: "Grand Opening: The Crafty Pint",
    start: new Date(2026, 6, 31, 12, 0),
    end: new Date(2026, 6, 31, 23, 0),
    desc: "A brand new taproom opening in the center.",
    imageUrl: "https://placehold.co/600x400?text=Grand+Opening",
    eventType: "Grand Openings",
  },
  {
    id: 49,
    title: "Town Square Zumba",
    start: new Date(2026, 6, 21, 18, 0),
    end: new Date(2026, 6, 21, 19, 0),
    desc: "High-energy outdoor workout class.",
    imageUrl: "https://placehold.co/600x400?text=Zumba",
    eventType: "Community",
  },
  {
    id: 50,
    title: "Local Art Auction",
    start: new Date(2026, 6, 26, 15, 0),
    end: new Date(2026, 6, 26, 18, 0),
    desc: "Bid on works from regional painters to support the local arts fund.",
    imageUrl: "https://placehold.co/600x400?text=Auction",
    eventType: "Arts & Culture",
  },
];

export function getEventColour(eventType) {
  switch (eventType) {
    case "Markets":
      return "#9c27b0"; // Purple
    case "Music":
      return "#ff9800"; // Orange
    case "Sport":
      return "#4caf50"; // Green
    case "Art & Culture":
      return "#f44336"; // Red
    case "Tours & History":
      return "#2196f3";
    case "Other":
      return "#e91e63"; // Pink
    case "Community":
      return "#00bcd4"; // Cyan
    case "Grand Openings":
      return "#795548"; // Brown
    default:
      return "#1976d2"; // Fallback Blue
  }
}

export const getEventIcon = (eventType) => {
  switch (eventType) {
    case "All":
      return <AllInclusiveIcon />;
    case "Markets":
      return (
        <span
          className="material-symbols-outlined"
          style={{
            fontVariationSettings: "'FILL' 1",
            fontSize: "24px",
          }}
        >
          store
        </span>
      );
    case "Music":
      return (
        <span
          className="material-symbols-outlined"
          style={{
            fontVariationSettings: "'FILL' 1",
            fontSize: "24px",
          }}
        >
          music_note_2
        </span>
      );
    case "Sport":
      return (
        <span
          className="material-symbols-outlined"
          style={{
            fontVariationSettings: "'FILL' 1",
            fontSize: "24px",
          }}
        >
          rewarded_ads
        </span>
      );
    case "Art & Culture":
      return (
        <span
          className="material-symbols-outlined"
          style={{
            fontVariationSettings: "'FILL' 1",
            fontSize: "24px",
          }}
        >
          theater_comedy
        </span>
      );
    case "Tours & History":
      return (
        <span
          className="material-symbols-outlined"
          style={{
            fontVariationSettings: "'FILL' 1",
            fontSize: "24px",
          }}
        >
          fort
        </span>
      );
    case "Other":
      return <StarIcon />;
    case "Community":
      return <PeopleIcon />;
    case "Grand Openings":
      return <StoreIcon />;
    default:
      return <PeopleIcon />;
  }
};

export const getAddress = ({ siteInfo }) => {
  console.log("🚀 ~ getAddress ~ siteInfo:", siteInfo);
  if (!siteInfo || !siteInfo.siteAddressLine1) return "Address not available";

  const line1 = siteInfo.siteAddressLine1 || "";
  const line2 = siteInfo.siteAddressLine2
    ? `, ${siteInfo.siteAddressLine2}`
    : "";
  const line3 = siteInfo.siteAddressLine3
    ? `, ${siteInfo.siteAddressLine3}`
    : "";
  const postcode = siteInfo.sitePostCode ? `, ${siteInfo.sitePostCode}` : "";

  return `${line1}${line2}${line3}${postcode}`;
};
